import {useEffect, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminClassesPrintStudentsModal = (props: { active: boolean, closeHandler: any,classId:number }) => {
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [checks,setChecks] = useState({
        name:true,
        grade:true,
        national:true,
        father:true,
        birthSerial:true,
        homeTell:true,
        birthDate:true,
        fatherCertificate:true,
        fatherTell:true,
        fatherJob:true,
        motherName:true,
        motherTell:true,
        motherCertificate:true,
        motherJob:true,
        zipCode:true,
        address:true,
        budget:true,
        maxBuyPerDay:true,
        isInside:true,
        className:true,
    });
    const goToPrint = () => {
        const x = {...checks};
        const classId = props.classId;
        const b2s = (v:boolean) => v ? '1' : '0';
        window.open(
            `/print/admins/students/${classId}/${b2s(x.name)}/${b2s(x.grade)}/${b2s(x.national)}/${b2s(x.father)}/${b2s(x.birthSerial)}/${b2s(x.homeTell)}/${b2s(x.birthDate)}/${b2s(x.fatherCertificate)}/${b2s(x.fatherTell)}/${b2s(x.fatherJob)}/${b2s(x.motherName)}/${b2s(x.motherTell)}/${b2s(x.motherCertificate)}/${b2s(x.motherJob)}/${b2s(x.zipCode)}/${b2s(x.address)}/${b2s(x.budget)}/${b2s(x.maxBuyPerDay)}/${b2s(x.isInside)}/${b2s(x.className)}`
        );
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>پرینت دانش‌آموزان</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="d-flex justify-content-between align-items-center">
                            <label>انتخاب موارد قابل چاپ:</label>
                            <button className="btn-pay" onClick={goToPrint}>
                                <b>چاپ</b>
                            </button>
                        </div>
                        {[
                            {key: "name", value: 'نام'},
                            {key: "grade", value: "پایه تحصیلی"},
                            {key: "national", value: 'کد ملی'},
                            {key: "father", value: 'نام پدر'},
                            {key: "birthSerial", value: "سریال شناسنامه"},
                            {key: "homeTell", value: 'شماره منزل'},
                            {key: "birthDate", value: 'تاریخ تولد'},
                            {key: "fatherCertificate", value: 'مدرک پدر'},
                            {key: "fatherTell", value: 'تلفن پدر'},
                            {key: "fatherJob", value: 'شغل پدر'},
                            {key: "motherName", value: 'نام مادر'},
                            {key: "motherTell", value: 'تلفن همراه مادر'},
                            {key: "motherCertificate", value: 'مدرک مادر'},
                            {key: "motherJob", value: 'شغل مادر'},
                            {key: "zipCode", value: 'کد پستی'},
                            {key: "address", value: 'آدرس'},
                            {key: "budget", value: 'موجودی حساب بوفه'},
                            {key: "maxBuyPerDay", value: 'سقف خرید روزانه بوفه'},
                            {key: "isInside", value: 'وضعیت حضور'},
                            {key: "className", value: 'نام کلاس'},
                        ].map((b, i) =>
                            <button key={"Kd82jDk28ifSsjG" + i} onClick={() => setChecks(v => {
                                let x = {...v};
                                // @ts-ignore
                                x[b.key] = !x[b.key];
                                return x;
                            })} className={
                                "techaran-checkbox" + // @ts-ignore
                                (checks[b.key] ? ' active' : '')
                            }>
                                <i><CheckIcon/></i>
                                <span>{b.value}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};